// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__m4x0V","selects":"Documents_selects__qTfk4"};